import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="w-full py-3 text-center text-xs text-slate-400 bg-transparent select-none font-medium">
      © 2026 Stackmentalist Ventures Pvt.Ltd
    </footer>
  );
};

export default Footer;
